import initialState from './initialState';
import { actionTypes } from './actions';

export default function propertyObjectsListFiltersReducer(state = initialState, action) {
  switch (action.type) {
    case actionTypes.SET_TYPE:
      return state.set('type', action.payload);
    case actionTypes.SET_TAX_AUTHORITY:
      return state.set('taxAuthority', action.payload);
    case actionTypes.SET_TAX_TYPE:
      return state.set('taxType', action.payload);
    case actionTypes.SET_ADJUSTMENT_SHOW:
      return state.set('adjustmentShow', action.payload);
    default:
      return state;
  }
}
